import React, { Component } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { openInInternalBrowser } from '../../lib/openURL';
import theme from '../../theme-config';

type Props = {
  children: any,
  style?: any,
  url: string,
};

class HyperText extends Component<Props> {
  goToUrl = () => {
    const { url } = this.props;

    openInInternalBrowser(url);
  };

  render() {
    const { children, style } = this.props;
    const textStyles = [styles.text, style];

    if (Platform.OS === 'web') {
      return (
        <Text accessibilityRole="link" style={textStyles} onPress={this.goToUrl}>
          {children}
        </Text>
      );
    }

    return (
      <Text onPress={this.goToUrl} style={textStyles}>
        {children}
      </Text>
    );
  }
}

const styles = StyleSheet.create({
  text: {
    fontFamily: theme.fontFamily,
    fontWeight: '500',
    textDecorationLine: 'underline',
  },
});

export default HyperText;
